import Vue from "vue";
import Router from "vue-router";
const login = () => import("@/views/login/login");
const Home = () => import("@/views/home/Home");
const User = () => import("@/views/user/User");
const ClassManagement = () => import("@/views/user/ClassManagement");
const CreateClass = () => import("@/views/user/CreateClass");
const ManageClass = () => import("@/views/user/ManageClass");
const MemberManagement = () => import("@/views/user/MemberManagement");
const Change = () => import("@/views/user/Change");
const Book = () => import("@/views/book/Books");
const AddBook = () => import("@/views/book/AddBook");
const BookRecommend = () => import("@/views/book/BookRecommend");
const EditBook = () => import("@/views/book/EditBook");
const bookAdministration = () => import("@/views/book/bookAdministration");
const Banner = () => import("@/views/banner/Banner");
const ExperienceNote = () => import("@/views/experienceNote/ExperienceNote");
const AddBanner = () => import("@/views/banner/AddBanner");
const EditBanner = () => import("@/views/banner/EditBanner");
const BannerSort = () => import("@/views/banner/BannerSort");
const ExperienceManagement = () =>
  import("@/views/studentRelease/ExperienceManagement");
const Cutaway = () => import("@/views/studentRelease/Cutaway");
const Roles = () => import("@/views/authorityManagement/Roles");
const AccountManagement = () =>
  import("@/views/authorityManagement/AccountManagement");
const McademicBooksManage = () =>
  import("@/views/academicBooks/academicBooksManage");
const McademicBooksInfo = () =>
  import("@/views/academicBooks/academicBooksInfo");
const EditBooksQues = () => import("@/views/academicBooks/editBooksQues");

import Cookies from "js-cookie";
Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "Login",
      component: login,
      meta: {
        title: "悠语文管理控制台",
      },
    },
    {
      path: "/home",
      name: "当前位置",
      component: Home,
      children: [
        {
          path: "/user",
          name: "用户中心",
          component: (r) =>
            require.ensure([], () => r(require("@/views/user/index")), "user"),
          children: [
            {
              path: "/",
              name: "用户管理",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/user/index")),
                  "user"
                ),
              meta: {
                title: "用户管理",
              },
              redirect: "/users",
              children: [
                {
                  path: "/user/change",
                  name: "查看用户",
                  component: Change,
                  meta: {
                    title: "查看用户",
                  },
                },
              ],
            },
            {
              path: "/users",
              name: "用户管理",
              component: User,
              meta: {
                title: "用户管理",
              },
            },
            {
              path: "/classManagement",
              name: "班级管理",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/user/index")),
                  "ClassManagement"
                ),
              meta: {
                title: "班级管理",
              },
              redirect: "/classManagements",
              children: [
                {
                  path: "/classManagement/createClass",
                  name: "创建班级",
                  component: CreateClass,
                  meta: {
                    title: "创建班级",
                  },
                },
                {
                  path: "/classManagement/manageClass",
                  name: "编辑班级",
                  component: ManageClass,
                  meta: {
                    title: "编辑班级",
                  },
                },
                {
                  path: "/classManagement/memberManagement",
                  name: "成员管理",
                  component: MemberManagement,
                  meta: {
                    title: "成员管理",
                  },
                },
              ],
            },
            {
              path: "/classManagements",
              name: "班级管理",
              component: ClassManagement,
              meta: {
                title: "班级管理",
              },
            },
          ],
        },
        {
          path: "/experienceNotes",
          name: "心得批改管理",
          component: ExperienceNote,
          meta: {
            title: "心得批改管理",
          },
        },
        {
          path: "/experienceNote",
          name: "心得批改管理",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/experienceNote/ExperienceNote")),
              "experienceNote"
            ),
          redirect: "/experienceNotes",
          meta: {
            title: "心得批改管理",
          },
          // redirect: '/experienceNotes',
          children: [],
        },
        {
          path: "/book",
          name: "书本资源管理",
          component: (r) =>
            require.ensure([], () => r(require("@/views/book/index")), "book"),
          children: [
            {
              path: "/",
              name: "书本管理",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/book/index")),
                  "book"
                ),
              meta: {
                title: "书本管理",
              },
              redirect: "/books",
              children: [
                {
                  path: "/book/addBook",
                  name: "添加书本",
                  component: AddBook,
                  meta: {
                    title: "添加书本",
                  },
                },
                {
                  path: "/book/editBook",
                  name: "编辑书本",
                  component: EditBook,
                  meta: {
                    title: "编辑书本",
                  },
                },
              ],
            },
            {
              path: "/books",
              name: "书本管理",
              component: Book,
              meta: {
                title: "书本管理",
              },
            },
            {
              path: "/bookRecommend",
              name: "书本推荐管理",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/book/bookAdministration")),
                  "bookRecommend"
                ),
              meta: {
                title: "书本推荐管理",
              },
              redirect: "/bookRecommends",
              children: [
                {
                  path: "/bookRecommend/bookAdministration",
                  name: "书本推荐管理",
                  component: bookAdministration,
                  meta: {
                    title: "书本推荐管理",
                  },
                },
              ],
            },
            {
              path: "/bookRecommends",
              name: "书本推荐管理",
              component: BookRecommend,
              meta: {
                title: "书本推荐管理",
              },
            },
          ],
        },
        {
          path: "/banner",
          name: "banner管理",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/banner/index")),
              "banner"
            ),
          redirect: "banners",
          meta: {
            title: "banner管理",
          },
          redirect: "/banners",
          children: [
            {
              path: "/banners/addBanner",
              name: "添加banner",
              component: AddBanner,
              meta: {
                title: "添加banner",
              },
            },
            {
              path: "/banners/editBanner",
              name: "编辑banner",
              component: EditBanner,
              meta: {
                title: "编辑banner",
              },
            },
            {
              path: "/banners/bannerSort",
              name: "banner排序",
              component: BannerSort,
              meta: {
                title: "banner排序",
              },
            },
          ],
        },
        {
          path: "/banners",
          name: "banner管理",
          component: Banner,
          meta: {
            title: "banner管理",
          },
        },
        {
          path: "/studentRelease",
          name: "学生发布管理",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/studentRelease/index")),
              "studentRelease"
            ),
          meta: {
            title: "banner管理",
          },
          children: [
            {
              path: "/",
              name: "文学圈管理",
              component: ExperienceManagement,
              meta: {
                title: "文学圈管理",
              },
            },
            {
              path: "/cutaway",
              name: "切图管理",
              component: Cutaway,
              meta: {
                title: "切图管理",
              },
            },
          ],
        },
        // 添加 学评书籍管理路由
        {
          path: "/academicBooks",
          name: "学评书籍管理",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/academicBooks/index")),
              "academicBooks"
            ),
          meta: {
            title: "学评书籍管理",
          },
          children: [
            {
              path: "/",
              name: "学评书籍管理列表",
              component: McademicBooksManage,
              meta: {
                title: "学评书籍管理列表",
              },
            },
            {
              path: "/McademicBooksInfo",
              name: "学评书籍管理详情",
              component: McademicBooksInfo,
              meta: {
                title: "学评书籍管理详情",
              },
            },
            {
              path: "/editBooksQues",
              name: "书本题目编辑",
              component: EditBooksQues,
              meta: {
                title: "书本题目编辑",
              },
            },
          ],
        },
        {
          path: "/roles",
          name: "权限管理",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/authorityManagement/index")),
              "authorityManagement"
            ),
          meta: {
            title: "权限管理",
          },
          children: [
            {
              path: "/",
              name: "角色管理",
              component: Roles,
              meta: {
                title: "角色管理",
              },
            },
            {
              path: "/accountManagement",
              name: "账号管理",
              component: AccountManagement,
              meta: {
                title: "账号管理",
              },
            },
          ],
        },
      ],
    },
  ],
});
router.beforeEach((to, from, next) => {
  const token = Cookies.get("token");
  if (token) {
    if (to.path == "/") {
      next("/login");
    } else {
      next();
    }
  } else {
    if (to.path == "/login") {
      next();
    } else {
      next("/login");
    }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js